import { AccessGroupCard, StyledLink } from "./AdminMainPage.styles";
import PageWrapper, { LoadingWrapper } from "app/components/PageWrapper";

import HStack from "shared/components/layout/stack/HStack";
import Icon from "shared/components/utils/Icon";
import Loading from "shared/components/feedback/loading/Loading";
import PropTypes from "prop-types";
import React from "react";
import SPACING from "shared/config/spacing";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import useAllPages from "shared/hooks/useAllPages";

export { StyledLink, AccessGroupCard } from "./AdminMainPage.styles";

export const Card = ({ title, description, to }) => (
    <StyledLink to={to}>
        <AccessGroupCard>
            <HStack
                align="center"
                justify="space-between"
                spacing={SPACING.One}
            >
                <Text variant="Headline_4" color="Black">
                    {title}
                </Text>
                <Icon
                    style={{ flexShrink: 0 }}
                    size={13}
                    name="caret-right"
                    color="Black"
                />
            </HStack>
            <Text variant="Body_2_1" color="Gray_2">
                {description}
            </Text>
        </AccessGroupCard>
    </StyledLink>
);

Card.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    to: PropTypes.string,
};

const AdminMainPage = () => {
    const { pages } = useAllPages();

    if (pages.isLoading) {
        return (
            <LoadingWrapper>
                <Loading text="Loading Page" />
            </LoadingWrapper>
        );
    }

    if (pages.isError) {
        return <>Error</>;
    }

    const adminModuleElements = pages.data.filter((d) => d.module === "Admin");

    const adminSections = adminModuleElements.filter(
        (element, index, arr) =>
            arr.findIndex(
                (d) => d.section !== "Admin" && element.section === d.section
            ) === index
    );

    return (
        <PageWrapper title="Admin" breadcrumbMarginBottom={"32px"}>
            <VStack spacing="Two">
                {adminSections.map((sectionData) => (
                    <VStack
                        key={sectionData.section}
                        spacing="One"
                        style={{ marginBottom: "1rem" }}
                    >
                        <Text variant="Headline_4" color="Gray_1">
                            {sectionData.section}
                        </Text>
                        <HStack wrap={true}>
                            {adminModuleElements
                                .filter(
                                    (m) => m.section === sectionData.section
                                )
                                .map((data) => (
                                    <Card
                                        key={data.route}
                                        title={data.name}
                                        description={data.description}
                                        to={data.route}
                                    />
                                ))}
                        </HStack>
                    </VStack>
                ))}
            </VStack>
        </PageWrapper>
    );
};

export default AdminMainPage;
